// extracted by mini-css-extract-plugin
export default {"login-wrap":"login-wrap--pzT9k","title":"title--feKj5"};